<template>
  <v-text-field
    label="Cliente (Nome ou Telefone)"
    v-model="clienteSelecionado"
  />
</template>

<script>
export default {
  name: 'FiltroCliente',
  data() {
    return {
      clienteSelecionado: ''
    }
  },
  watch: {
    clienteSelecionado() {
      this.$emit('filtrar-cliente', {
        cliente: this.clienteSelecionado
      })
    }
  }
}
</script>
